export const urlHome = () => `/`;
//
//
// Auth URLs
export const urlLogin = () => `/login`;
export const urlSignup = () => `/signup`;
//
//
// Profile URLs
export const urlProfile = (id: string) => `/club/${id}/perfil`;
//
//
// Main sidebar URLs
export const urlControlPanel = (id: string) => `/club/${id}`;
export const urlCourt = (id: string, courtId: string) => `/club/${id}/canchas/${courtId}`;
export const urlCourtList = (id: string) => `/club/${id}/canchas`;
export const urlUserList = (id: string) => `/club/${id}/usuarios`;
//
//
// Config URLs
export const urlConfig = (id: string, tab?: string) => `/club/${id}/gestion${tab ? `/${tab}` : ''}`;
//
//
// Court URLs
export const urlCourtReservations = (id: string, courtId: string, date?: string) =>
  `/club/${id}/canchas/${courtId}/reservations${date ? `/${date}` : ''}`;
//
//
// Tournament URLs
export const urlTournamentList = (id: string) => `/club/${id}/torneos`;
export const urlTournament = (id: string, tournamentId: string, status?: string) =>
  `/club/${id}/torneos/${tournamentId}${status ? `/${status}` : ''}`;
//
//
// Public Tournament URLs
export const urlPublicTournament = (id: string, status?: string) =>
  `/torneo/${id}${status ? `/${status}` : ''}`;
export const urlTournamentRegisterSuccess = () => `/torneo/registro/exito`;
export const urlTournamentConfirmRegister = (token?: string) =>
  `/confirm-registration${token ? `?token=${token}` : ''}`;
//
//
// Product URLs
export const urlProductList = (clubId: string) => `/club/${clubId}/productos`;
export const urlCreateProduct = (clubId: string) => `/club/${clubId}/productos/nuevo`;
export const urlEditProduct = (clubId: string, productId: string) =>
  `/club/${clubId}/productos/${productId}`;
export const urlCategoryList = (clubId: string) => `/club/${clubId}/productos/categorias`;
export const urlEditCategory = (clubId: string, categoryId: string) =>
  `/club/${clubId}/productos/categorias/${categoryId}`;
export const urlSales = (clubId: string) => `/club/${clubId}/ventas`;
//
//
// Player URLs
export const urlPlayerList = (clubId: string) => `/club/${clubId}/jugadores`;
//
//
// Open Matches URLs
export const urlOpenMatches = (clubId: string) => `/club/${clubId}/partidos-abiertos`;
//
//
// Cashier Mode URLs
export const urlCashierMode = (clubId: string) => `/club/${clubId}/caja`;
